import { createFileRoute } from "@tanstack/react-router";
import { ShieldAlertIcon } from "lucide-react";
import { HeldSignupList } from "@/components/admin/safeguards/held-signup-list";
import { heldSignupsQuery } from "@/hooks/use-safeguards";
import { requireAdminSection } from "@/lib/admin-guard";

export const Route = createFileRoute("/_admin/review")({
  // Admins only: rejecting bans the account.
  beforeLoad: ({ context }) => requireAdminSection(context.auth.capabilities),
  loader: ({ context }) => context.queryClient.ensureQueryData(heldSignupsQuery),
  component: AdminReviewPage,
});

function AdminReviewPage() {
  return (
    <div className="flex flex-1 flex-col gap-8 p-6">
      <header className="flex flex-col gap-2">
        <div className="flex items-center gap-2 font-medium text-muted-foreground text-xs uppercase tracking-wider">
          <ShieldAlertIcon className="size-3.5" />
          Operate
        </div>
        <div className="flex flex-col gap-1">
          <h1 className="font-heading font-semibold text-3xl tracking-tight">Sign-up review</h1>
          <p className="max-w-2xl text-muted-foreground text-sm">
            New accounts held because their address created too many accounts in a day. A held
            account can sign in but can't send anything. Approve the genuine ones; rejecting bans
            the account and signs it out. Change the threshold under Settings → Safeguards.
          </p>
        </div>
      </header>

      <HeldSignupList />
    </div>
  );
}
